<template>
  <v-container ref="form">
    <v-row justify="center" class="mb-5">
      <h1 v-show="!mostraEscolheu" style="color: #f5cb5d">Escolha um local</h1>
    </v-row>
    <v-row justify="center">
      <v-col cols="11" class="campos" sm="4" md="5" xl="3">
        <v-autocomplete
          dark
          :loading="loadingEmail"
          :disabled="loadingEmail"
          :items="praca"
          ref="cidade"
          v-model="pax.cidade"
          label="Escolha o local:"
          placeholder="Escolha o local:"
          outlined
          dense
          :rules="[rules.required]"
          required
          @change="escolhidoCidade"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row justify="center" class="mt-5">
      <label
        v-show="erroServidor.mostra"
        style="color: #f5cb5d; font-size: 1.3rem"
        v-html="erroServidor.texto"
      ></label>
    </v-row>
    <div v-show="mostraEscolheu">
      <v-row justify="center">
        <v-col cols="11" class="campos" sm="4" md="5" xl="3">
          <v-text-field
            dark
            :loading="loadingEmail"
            :disabled="loadingEmail"
            ref="nome"
            v-model="pax.nome"
            label="Nome:"
            placeholder="Nome completo"
            hint="Digite seu nome sem abreviação"
            outlined
            dense
            :rules="[rules.required]"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="11" class="campos" sm="4" md="5" xl="3">
          <v-text-field
            dark
            color="white"
            :loading="loadingEmail"
            :disabled="loadingEmail"
            ref="email"
            v-model="pax.email"
            label="E-mail:"
            placeholder="Email:"
            :hint="cadastrado"
            persistent-hint
            outlined
            dense
            :rules="[rules.required, rules.email]"
            required
            @blur="validaemail()"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <div v-if="mostraBtnInscreva">
        <v-row justify="center">
          <v-col cols="11" class="campos" sm="4" md="5" xl="3">
            <v-text-field
              dark
              @keyup="maxCel1"
              maxlength="13"
              :loading="loadingEmail"
              :disabled="loadingEmail"
              ref="celular"
              v-model="pax.celular"
              label="Celular"
              placeholder="Celular"
              outlined
              dense
              hint="Somente números"
              :rules="[rules.required, rules.celular]"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="11" class="campos" sm="4" md="5" xl="3">
            <v-autocomplete
              dark
              :loading="loadingEmail"
              :disabled="loadingEmail"
              :items="registro"
              ref="tipoDoc"
              v-model="tipoDoc"
              label="Registro Profissional:"
              placeholder="Registro Profissional:"
              outlined
              dense
              :rules="[rules.requiredSelecao]"
              required
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row justify="center" v-show="tipoDoc == 'crm'">
          <v-col cols="11" class="campos" sm="6" md="2" xl="1">
            <v-autocomplete
              dark
              :loading="loadingEmail"
              :disabled="loadingEmail"
              :items="uflist"
              ref="uf_crm"
              v-model="pax.uf_crm"
              label="UF do CRM:"
              placeholder="UF do CRM:"
              outlined
              dense
              :rules="[rules.required]"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="11" class="campos" sm="4" md="3" xl="2">
            <v-text-field
              dark
              :loading="loadingEmail"
              :disabled="loadingEmail"
              ref="crm"
              v-model="pax.crm"
              label="CRM:"
              placeholder="CRM:"
              outlined
              dense
              hint="Somente números"
              :rules="[rules.required]"
              required
              maxlength="7"
              @keyup="numero"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" v-show="tipoDoc == 'crf'">
          <v-col cols="11" class="campos" sm="6" md="2" xl="1">
            <v-autocomplete
              dark
              :loading="loadingEmail"
              :disabled="loadingEmail"
              :items="uflist"
              ref="uf_crf"
              v-model="pax.uf_crm"
              label="UF do CRF:"
              placeholder="UF do CRF:"
              outlined
              dense
              :rules="[rules.required]"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="11" class="campos" sm="4" md="3" xl="2">
            <v-text-field
              dark
              :loading="loadingEmail"
              :disabled="loadingEmail"
              ref="crf"
              v-model="pax.crm"
              label="CRF:"
              placeholder="CRF:"
              outlined
              dense
              hint="Somente números"
              :rules="[rules.required]"
              required
              @keyup="numero"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" v-show="tipoDoc == 'coren'">
          <v-col cols="11" class="campos" sm="6" md="2" xl="1">
            <v-autocomplete
              dark
              :loading="loadingEmail"
              :disabled="loadingEmail"
              :items="uflist"
              ref="uf_coren"
              v-model="pax.uf_crm"
              label="UF do COREN:"
              placeholder="UF do COREN:"
              outlined
              dense
              :rules="[rules.required]"
              required
            ></v-autocomplete>
          </v-col>
          <v-col cols="11" class="campos" sm="4" md="3" xl="2">
            <v-text-field
              dark
              :loading="loadingEmail"
              :disabled="loadingEmail"
              ref="coren"
              v-model="pax.crm"
              label="COREN:"
              placeholder="COREN:"
              outlined
              dense
              hint="Somente números"
              :rules="[rules.required]"
              required
              @keyup="numero"
            ></v-text-field>
          </v-col>
        </v-row>

        <!--Termos----checkbox--->
        <v-row justify="center" class="mt-2">
          <v-col md="3" cols="10" class="c-termos">
            <v-row>
              
                <small style="text-align: left;">
                  Os dados pessoais coletados em razão deste evento serão
                  tratados em total conformidade com a Lei Federal nº
                  13.709/2018 (Lei Geral de Proteção de Dados).
                  <a
                    href="https://cdn.igorsvp.com.br/termos/igo/TERMOS-IGORSVP.pdf"
                    target="_blank"
                    >clique aqui para ver termo completo</a
                  ></small
                >
            
                <v-checkbox
                  dark
                  color="#f5cb5d"
                  ref="lgpd"
                  v-model="ckLgpd"
                  label="Aceito os termos LGPD"
                  value="Convidado aceitou os termos LGPD"
                  class="mt-0 txt-chek"
                ></v-checkbox>
             
            </v-row>

            <v-row class="mt-0" v-if="false">
              <v-checkbox
                color="#f5cb5d"
                dark
                class="mt-2 txt-chek"
                v-model="ckNoti"
                label="Aceito receber notificações referente ao evento"
                value="Aceitou receber notificações referente ao evento"
              ></v-checkbox>
            </v-row>
          </v-col>
        </v-row>

        <!--fim-Termos----checkbox--->
        <v-row justify="center" class="mt-5">
          <label v-show="msgPreencha" style="color: #f5cb5d; font-size: 1.3rem"
            >Preencha corretamente o campo {{ erroCampo.texto }}!</label
          >
        </v-row>
        <v-row justify="center" class="mt-5">
          <v-btn
            v-if="mostraBtnInscreva"
            dark
            class="ma-2 botao-pulse"
            outlined
            :loading="loading4"
            :disabled="loading4"
            color="#f5cb5d"
            @click="maqueado"
          
          >
          <!-- @click="submit" -->
            Inscrever
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>mdi-cached</v-icon>
              </span>
            </template>
          </v-btn>
        </v-row>
        <v-row justify="center" class="mt-5">
          <label
            v-show="msgErroGravar.mostra"
            style="color: #f5cb5d; font-size: 1.3rem"
            >{{ msgErroGravar.texto }}</label
          >
        </v-row>
      </div>
      <input type="hidden" id="cpip" />
      <v-col cols="auto">
        <v-dialog
          v-model="dialogo"
          transition="dialog-top-transition"
          max-width="500"
          persistent
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar class="cabecalho-dialogo">{{
                d_msg.titulo
              }}</v-toolbar>
              <v-card-text>
                <div
                  class="text pa-10"
                  style="font-size: 1.2rem"
                  v-html="d_msg.texto"
                ></div>

                <div
                  class="text pl-10 pr-10"
                  style="font-size: 1.2rem"
                  v-html="d_msg.texto2"
                ></div>
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false">Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </div>
  </v-container>
</template>
<script>
const that = this;
import {
  baseEventoUrl,
  basePaxUrl,
  eventoID,
  baseCpfUrl,
  baseVerificaCidade,
  baseVerificaEmail,
  baseGravaPaxEvento,
} from "@/global";
import JQuery from "jquery";
import axios from "axios";
window.$ = JQuery;
export default {
  data: () => ({
    msgErroGravar: { texto: "", mostra: false },
    tipoDoc: "",
    registro: [
      { text: "CRM", value: "crm" },
      { text: "CRF", value: "crf" },
      // { text: "COREN", value: "coren" },
    ],
    id_evento: 42,
    banco: "astrazeneca",
    mostraEscolheu: false,
    pax: {
      nome: "",
      email: "",
      celular: "",
      uf_crm: "",
      crm: "",
      cidade: "",
      id_evento: 0,
      banco: "",
      tipoDoc: "",
      qtd: "",
      // especialidade: this.pax.especialidade,
    },
    erroCampo: { texto: "" },
    erroServidor: { texto: "", mostra: false },
    dialogo: false,
    d_msg: {
      texto: "",
      texto2: "",
      titulo: "",
    },

    mostraBtnInscreva: true,
    msgPreencha: false,
    evento: {},
    vagas: 0,
    // pax: [],
    status: {},
    idDopax: "",
    loader: [],
    loading4: false,
    loadingEmail: false,
    formHasErrors: false,
    ckNoti: ["Aceitou receber notificações referente ao evento"],
    ckLgpd: "",
    usuario: {},
    praca: [
      { text: "São Paulo - JW MARRIOT - TORRE HOTEL", value: "São Paulo" },
      { text: "Rio de Janeiro - HILTON COPACABANA", value: "Rio de Janeiro" },
      { text: "Porto Alegre - HILTON MOINHOS DE VENTO", value: "Porto Alegre" },
      { text: "Brasília - COMPLEXO BRASIL 21", value: "Brasília" },
      { text: "Belo Horizonte - MERCURE LOURDES", value: "Belo Horizonte" },
      { text: "Fortaleza - LUZEIROS", value: "Fortaleza" },
    ],
    rules: {
      celular: (value) => {
        if (value != undefined) {
          if (value.length < 11) {
            return "Celular inválido";
          } else return true;
        } else return true;
      },
      crm: (value) => {
        if (value != undefined) {
          if (value.length < 7) {
            return "Digite os 7 numeros do CRM";
          } else return true;
        } else return true;
      },
      required: (value) => !!value || "Por favor preencha este campo.",
      requiredSelecao: (value) => !!value || "Por favor escolha uma opção.",
      counter: (value) => value.length <= 20 || "Max 20 caracteres",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return pattern.test(value) || "E-mail inválido.";
      },
    },
    cadastrado: "",
  }),

  computed: {
    uflist() {
      return this.$store.state.uf;
    },
  },

  watch: {
    name() {
      this.errorMessages = "";
    },
  },

  methods: {
    maqueado(){
      this.d_msg.texto = "Master Class HER2LOW";
          this.d_msg.texto2 =
            "Obrigado por sua inscrição no evento <b>Master Class HER2LOW</b><br>em breve você receberá mais informações.";
          this.d_msg.titulo = "Inscrito com sucesso!";
          this.dialogo = true;
          this.loading4 = false;
          this.mostraEscolheu = false;
          this.resetForm();
          this.msgErroGravar.mostra = false;
          this.msgErroGravar.texto = "";
    },
    escolhidoCidade() {
      let cidade = this.pax.cidade;
      this.ExisteVagas(cidade);
      // this.mostraEscolheu = true
    },
    maxCel1(valor) {
      //console.log(valor, "valoe", this.pax);
      //  let v = valor.target.value;
      this.pax.celular = valor.target.value.replace(/\D/g, "");
      //valor.target.value = valor.target.value.replace(/\D/g, "");
    },
    loading(...loads) {
      const l = loads;

      l.forEach((f) => {
        this[f] = !this[f];
        setTimeout(() => (this[f] = false), 3000);
      });
      // this[l] = !this[l];

      this.loader = [];
    },
    validaemail() {
      const Valido = this.emailInvalido();

      if (Valido) {
        const email = this.pax.email;
        this.ExisteUsuarioEmail(email);
      }
      return Valido;
    },
    async ExisteVagas(cidade, modo = "consulta") {
      this.msgErroGravar.mostra = false;
      this.msgErroGravar.texto = "";
      this.erroServidor.texto = "";
      this.erroServidor.mostra = false;
      let virtual = this.$route.query.virtual;
      // this.loadingEmail = true;

      const url = `${baseVerificaCidade}`;
      let formdata = {
        cidade: cidade,
        id_evento: this.id_evento,
        banco: this.banco,
      };
      // let config = {
      //   headers: {
      //     "Content-Type": "application/javascript",
      //   },
      // };
      this.mostraEscolheu = true;
      return
      // await axios
      //   .post(url, formdata)
      //   .then((res) => {
      //     this.vagas = res.data;
      //     console.log(this.vagas, "existe vagas?");
      //     if (this.vagas == 0) {
      //       this.dialogo = true;
      //       this.d_msg.titulo = "Indisponível";
      //       this.d_msg.texto =
      //         "Infelizmente o local escolhido atingiu o limite de vagas disponíveis.<br><br>Você ainda pode participar de forma virtual.<br>";
      //       this.$store.state.mostraPresencial = false;
      //       this.$store.state.mostraVirtual = true;
      //       this.mostraEscolheu = false;
      //       this.erroServidor.texto =
      //         "Clique no botão <b>QUERO PARTICIPAR VIRTUAL</b> para se cadastrar!";
      //       this.erroServidor.mostra = true;
      //       this.resetForm();
      //       this.pax.cidade = " ";
      //       if (!virtual) {
      //         this.$store.state.mostraPresencial = false;
      //         this.$store.state.mostraVirtual = true;
      //       }
      //     } else {
      //       if (this.vagas >= 1) {
      //         this.pax.qtd = this.vagas;
      //         this.$store.state.mostraPresencial = true;
      //         this.$store.state.mostraVirtual = true;
      //         this.mostraEscolheu = true;
      //         this.erroServidor.texto = "";
      //         this.erroServidor.mostra = false;
      //         if (!virtual) {
      //           this.$store.state.mostraPresencial = false;
      //           this.$store.state.mostraVirtual = false;
      //         }
      //         console.log(this.vagas, "vagas apos consulta");
      //         if (modo == "gravar") {
      //           this.gravaCred();
      //         }
      //       }
      //     }

       
      //     this.loadingEmail = false;
      //   })
      //   .catch((err) => {
      //     console.log(err,"erro-existe vagas")

      //     this.loadingEmail = false;
      //     this.erroServidor.texto = "Erro inesperado tente novamente!";
      //     this.erroServidor.mostra = true;
      //   });
    },
    async ExisteUsuarioEmail(email) {
      return
      // this.loadingEmail = true;
      // this.cadastrado = "";
      // const url = `${baseVerificaEmail}`;
      // let formdata = {
      //   email: email,
      //   id_evento: this.id_evento,
      //   banco: this.banco,
      // };
      // let config = {
      //   headers: {
      //     "Content-Type": "application/javascript",
      //   },
      // };
      // await axios
      //   .post(url, formdata)
      //   .then((res) => {
      //     let existe = res.data;

      //     if (existe == "CADASTRADO") {
      //       this.mostraBtnInscreva = false;
      //       this.cadastrado = "E-mail já cadastrado!";
      //       this.dialogo = true;
      //       this.d_msg.titulo = "Usuário já inscrito";
      //       this.d_msg.texto = "Você já está inscrito.";
      //     } else {
      //       this.mostraBtnInscreva = true;
      //       this.cadastrado = "";
      //       // this.$refs['email'].validate(false);
      //     }
      //     this.loadingEmail = false;
      //   })
      //   .catch(() => {
      //     this.loadingEmail = false;
      //     this.cadastrado = "Erro inesperado tente novamente!";
      //   });
    },
    getIp() {
      $.getJSON(
        "https://api.ipify.org?format=jsonp&callback=?",
        function (json) {
          document.querySelector("#cpip").value = json.ip;
          return json.ip;
        }
      );
    },

    numero(valor) {
      this.pax.crm = valor.target.value.replace(/\D/g, "");
    },
    emailInvalido() {
      const value = this.pax.email;
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!pattern.test(value)) {
        this.formHasErrors = true;

        return false;
      }
      return true;
    },
    addressCheck() {
      this.errorMessages =
        this.address && !this.name ? `Hey! I'm required` : "";

      return true;
    },
    resetForm() {
      this.errorMessages = [];
      this.formHasErrors = false;
      this.tipoDoc = "";
   
      Object.keys(this.pax).forEach((f) => {
        console.log(this.$refs[f],f)
        this.$refs[f]? this.$refs[f].reset():"";
        this.pax[f] = "";
      });
    },

    submit() {
      this.msgPreencha = false;
      this.erroCampo.texto = "";
      //       for (var f in this.pax) {
      //         if(!this.pax[f]){
      //         this.formHasErrors = true;
      //         this.$refs[f].validate(true);
      //         this.erroCampo.texto = f
      //         this.msgPreencha = true;
      //         return;
      //       }
      //     console.log(f, this.pax[f]);
      // }
      if (this.pax.cidade.length < 1) {
        this.formHasErrors = true;
        this.$refs["cidade"].validate(true);
        this.erroCampo.texto = "escolha um local";
        this.msgPreencha = true;
        return;
      }
      if (this.pax.nome.length < 3) {
        this.formHasErrors = true;
        this.$refs["nome"].validate(true);
        this.erroCampo.texto = "nome";
        this.msgPreencha = true;
        return;
      }

      if (!this.emailInvalido()) {
        this.$refs["email"].validate(true);
        this.erroCampo.texto = "e-mail";
        this.msgPreencha = true;
        return;
      }

      if (this.pax.celular.length < 11) {
        this.formHasErrors = true;
        this.$refs["celular"].validate(true);
        this.erroCampo.texto = "celular";
        this.msgPreencha = true;
        return;
      }
      if (this.tipoDoc == "" || this.tipoDoc === null || this.tipoDoc === undefined) {
        this.formHasErrors = true;
        this.$refs["tipoDoc"].validate(true);
        this.erroCampo.texto = "registro profissional";
        this.msgPreencha = true;
        return;
      }
      if (this.tipoDoc == "crm") {
        if (this.pax.uf_crm.length < 1) {
          this.formHasErrors = true;
          this.$refs["uf_crm"].validate(true);
          this.erroCampo.texto = "UF CRM";
          this.msgPreencha = true;
          return;
        }
        if (this.pax.crm.length < 2) {
          this.formHasErrors = true;
          this.$refs["crm"].validate(true);
          this.erroCampo.texto = "CRM";
          this.msgPreencha = true;
          return;
        }
      }
      if (this.tipoDoc == "crf") {
        if (this.pax.uf_crm.length < 1) {
          this.formHasErrors = true;
          this.$refs["uf_crf"].validate(true);
          this.erroCampo.texto = "UF CRF";
          this.msgPreencha = true;
          return;
        }
        if (this.pax.crm.length < 2) {
          this.formHasErrors = true;
          this.$refs["crf"].validate(true);
          this.erroCampo.texto = "CRF";
          this.msgPreencha = true;
          return;
        }
      }
      if (this.tipoDoc == "coren") {
        if (this.pax.uf_crm.length < 1) {
          this.formHasErrors = true;
          this.$refs["uf_coren"].validate(true);
          this.erroCampo.texto = "UF COREN";
          this.msgPreencha = true;
          return;
        }
        if (this.pax.crm.length < 2) {
          this.formHasErrors = true;
          this.$refs["coren"].validate(true);
          this.erroCampo.texto = "COREN";
          this.msgPreencha = true;
          return;
        }
      }
      this.pax.ip_usuario = document.querySelector("#cpip").value;

      this.formHasErrors = false;
      if (!this.ckLgpd) {
        this.d_msg.texto = "Para continuar você deve aceitar os termos LGPD";
        this.d_msg.texto2 = "";
        this.d_msg.titulo = "Aceite LGPD";
        this.dialogo = true;

        return;
      } else {
        this.d_msg.texto = "";
        this.d_msg.texto2 = "";
        this.d_msg.titulo = "";
        this.dialogo = false;
      }

      this.msgPreencha = true;
      if (!this.formHasErrors) {
        this.msgPreencha = false;
        this.ExisteVagas(this.pax.cidade, "gravar");
      }
    },
    async gravaCred() {
      this.msgErroGravar.mostra = false;
      this.msgErroGravar.texto = "";
      this.pax.banco = this.banco;
      this.pax.id_evento = this.id_evento;
      this.pax.tipoDoc = this.tipoDoc;
      const url = `${baseGravaPaxEvento}`;
      //      this.loader1 = true;
      this.loading4 = true;
      const token =
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InJhZmFlbEBpZ28iLCJyb2xlIjpbImFkbWluaXN0cmFkb3IiLCJsYW5kcGFnZSJdLCJpZF9ldmVudG8iOiIxNDkiLCJpZF9jcmVkIjoiMzU3NSIsImUtbWFpbCI6IiIsIm5vbWVfdXN1YXJpbyI6InJhZmFlbEBpZ28iLCJuaXZlbCI6ImFkbWluaXN0cmFkb3IiLCJjYXRlZ29yaWEiOiJJR09fUlNWUCIsImlkX3VzdWFyaW8iOiIzNTc1IiwiYmFuY28iOiJNQ0kiLCJuYmYiOjE2NjQ3NDIxMzYsImV4cCI6MTY3MjUxODEzNSwiaWF0IjoxNjY0NzQyMTM2fQ.zUq6uO86gKsrxRSCicJVyK-DunQJskV3j85fL0R0amE";
      this.msgPreencha = false;
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      await axios
        .post(url, this.pax, config)
        .then((res) => {
          //  console.log("retorno do banco", res.data);
          ///this.editedItem = res.data;
          console.log(res.data, "gravacao");
          this.d_msg.texto = "Master Class HER2LOW";
          this.d_msg.texto2 =
            "Obrigado por sua inscrição no evento <b>Master Class HER2LOW</b><br>em breve você receberá mais informações.";
          this.d_msg.titulo = "Inscrito com sucesso!";
          this.dialogo = true;
          this.loading4 = false;
          this.mostraEscolheu = false;
          this.resetForm();
          this.msgErroGravar.mostra = false;
          this.msgErroGravar.texto = "";
          // this.loading("loadingEmail", "loading4");
        })
        .catch((err) => {
          this.msgErroGravar.mostra = true;
          this.msgErroGravar.texto = "Erro inesperado tente novamente!";
          this.loading4 = false;
          console.log(err, "erro do gravar");
        });
      // .finally(() => {
      //   console.log(this.editedItem, "finaly");
      // });
    },
  },
  mounted() {
    this.getIp();
  },
};
</script>

<style >
label > .theme--light {
  color: white !important;
}
.cabecalho-dialogo {
  color: black !important;
  font-size: 1.2rem;
  font-weight: 600;
  background-color: var(--cor-secundaria) !important;
}
.u-form-checkbox {
  font-size: 1rem;
}
.campos {
  padding-bottom: 0;
  padding-top: 0;
}
.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* background-color: white !important; */
  font-size: 1.2rem;
}

.c-termos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>